export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-8">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 lg:grid-cols-[1.4fr_0.8fr_0.8fr_1fr] gap-8">
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="8" height="8" rx="2" fill="white" fillOpacity="0.95"/><rect x="13" y="3" width="8" height="8" rx="2" fill="white" fillOpacity="0.65"/><rect x="3" y="13" width="8" height="8" rx="2" fill="white" fillOpacity="0.65"/><rect x="13" y="13" width="8" height="8" rx="2" fill="white" fillOpacity="0.45"/></svg>
              </div>
              <span className="font-semibold tracking-tight text-white">draunt</span>
            </div>
            <p className="mt-3 text-sm leading-6 text-white/45 max-w-[300px]">Providing high-quality apps to make your life easier and more productive. Crafted in Washington, USA.</p>
          </div>
          <div>
            <div className="text-xs tracking-[0.16em] text-white/30 font-medium">PRODUCT</div>
            <div className="mt-4 space-y-2.5 text-sm text-white/55">
              <a href="/#apps" className="block hover:text-white transition">View Apps</a>
              <a href="/contact" className="block hover:text-white transition">Contact</a>
            </div>
          </div>
          <div>
            <div className="text-xs tracking-[0.16em] text-white/30 font-medium">COMPANY</div>
            <div className="mt-4 space-y-2.5 text-sm text-white/55">
              <a href="/contact" className="block hover:text-white transition">Contact</a>
              <a href="/privacy" className="block hover:text-white transition">Privacy</a>
              <a href="/terms" className="block hover:text-white transition">Terms</a>
            </div>
          </div>
          <div>
            <div className="text-xs tracking-[0.16em] text-white/30 font-medium">GET THE APPS</div>
            <p className="mt-4 text-sm text-white/45">Available on iPhone & iPad.</p>
            <a href="/#apps" className="mt-3 inline-flex">
              <img src="/apps/app-store-badge.svg" alt="Download on the App Store" className="h-10 w-auto" />
            </a>
            <div className="mt-3 text-[11px] text-white/25">© {new Date().getFullYear()} Draunt. All rights reserved.</div>
          </div>
        </div>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/30">
          <span>© {new Date().getFullYear()} Draunt</span>
        </div>
      </div>
    </footer>
  );
}
